// apps/booth-web/src/i18n/boothLanguage.ts
import type { Route } from "../store/router";
import type { Language } from "./locale";

/**
 * 부스 기본 언어가 (로드·refresh 로) 들어왔을 때 화면 언어를 어떻게 할지 —
 * 어트랙트면 즉시 부스 언어, 손님 세션 중이면 현재 언어 유지(리셋 때 복귀).
 * BOOTH-116
 */
export function languageOnBoothConfig(route: Route, boothLanguage: Language, current: Language): Language {
  return route === "attract" ? boothLanguage : current;
}

/**
 * 세션 리셋 뒤 화면 언어 — 항상 부스 기본 언어.
 * BOOTH-116
 */
export function languageOnReset(boothLanguage: Language): Language {
  return boothLanguage;
}
